import React from 'react'
import Individual from './Individual'

const GetStarted = () => {
  return (
    <div>
     <Individual/>
    </div>
  )
}

export default GetStarted